// src/components/home/OfficeHours.jsx

import React, { useState } from 'react';
import { FaClock, FaCalendarTimes, FaCoffee } from 'react-icons/fa';

const OfficeHours = () => {
    // State untuk melacak tab mana yang aktif
    const [activeTab, setActiveTab] = useState('indonesia');

    // Data untuk jam kerja kantor (Indonesia)
    const officeHoursDataIndonesia = [
        { day: 'Selasa - Sabtu', description: '', time: '09.00 - 17.00 WITA', icon: <FaClock className="text-2xl text-blue-500" /> },
        { day: 'Istirahat', description: '', time: '12.00 - 13.00 WITA', icon: <FaCoffee className="text-2xl text-yellow-500" /> },
        { day: 'Senin & Libur Nasional', description: '', time: 'TUTUP', icon: <FaCalendarTimes className="text-2xl text-red-500" /> },
    ];

    // Data untuk jam kerja kantor (English)
    const officeHoursDataEnglish = [
        { day: 'Tuesday - Saturday', description: '', time: '09.00 - 17.00 (+8 UTC)', icon: <FaClock className="text-2xl text-blue-500" /> },
        { day: 'Lunch Break', description: '', time: '12.00 - 13.00 (+8 UTC)', icon: <FaCoffee className="text-2xl text-yellow-500" /> },
        { day: 'Monday & Public Holidays', description: '', time: 'CLOSED!', icon: <FaCalendarTimes className="text-2xl text-red-500" /> },
    ];

    // Menggunakan data yang sesuai dengan tab yang aktif
    const currentData = activeTab === 'indonesia' ? officeHoursDataIndonesia : officeHoursDataEnglish;

    return (
        <section className="bg-gray-50 py-12 px-6 rounded-2xl shadow-xl">
            <div className="max-w-4xl mx-auto text-center">
                {/* Judul Utama */}
                <div className="flex flex-col items-center justify-center space-y-2 mb-8">
                    <FaClock className="text-5xl text-blue-400" />
                    <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 tracking-tight">
                        Jam Kerja <br />Kantor Gereja
                    </h2>
                    <p className="text-lg text-gray-500 font-light italic">(Office Hour)</p>
                </div>

                {/* Tombol Tab */}
                <div className="flex justify-center mb-8 space-x-4">
                    <button
                        onClick={() => setActiveTab('indonesia')}
                        className={`py-2 px-6 rounded-full font-bold transition-colors duration-300 ease-in-out ${activeTab === 'indonesia' ? 'bg-blue-500 text-white shadow-md' : 'bg-white text-gray-700'}`}
                    >
                        Indonesia
                    </button>
                    <button
                        onClick={() => setActiveTab('english')}
                        className={`py-2 px-6 rounded-full font-bold transition-colors duration-300 ease-in-out ${activeTab === 'english' ? 'bg-blue-500 text-white shadow-md' : 'bg-white text-gray-700'}`}
                    >
                        English
                    </button>
                </div>

                {/* Konten yang disesuaikan berdasarkan tab */}
                <div className="mt-8 space-y-4">
                    {currentData.map((item, index) => (
                        <div
                            key={index}
                            className="bg-white p-6 rounded-2xl shadow-md flex justify-between items-center"
                        >
                            <div className="text-left flex items-center space-x-3">
                                {item.icon}
                                <div>
                                    <h3 className="text-xl font-bold text-gray-800">{item.day}</h3>
                                    <p className="text-blue-500">{item.description}</p>
                                </div>
                            </div>
                            <div className="text-right">
                                <p className="text-gray-900 font-extrabold text-2xl">{item.time}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default OfficeHours;